import React from 'react';
import Icon from '@/components/Icon';
import FilterChip from './FilterChip';

const STATUS_OPTIONS = [
  { v: 'active',  label: 'Только активные' },
  { v: 'archive', label: 'Только архив' },
  { v: 'all',     label: 'Активные + архив' },
];

export default function StudentsFilterBar({
  filters, setFilters, search, setSearch, totalShown, total, onClearAll,
  canCreate, onCreate,
}) {
  // 'active' — дефолт, поэтому «фильтр включён» считаем по отклонению от него.
  const hasActive = filters.status !== 'active' || search.length > 0;

  return (
    <div className="filterbar">
      <div className="filterbar__row">
        <div className="search">
          <Icon name="search" size={13} />
          <input
            placeholder="Найти ученика по ФИО, классу или телефону родителя…"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          {search && (
            <button className="search__clear" onClick={() => setSearch('')}>
              <Icon name="x" size={11} />
            </button>
          )}
        </div>

        <div className="chipgroup">
          <FilterChip
            label="Статус"
            value={filters.status}
            options={STATUS_OPTIONS}
            onChange={(v) => setFilters({ ...filters, status: v })}
          />
        </div>

        {hasActive && (
          <button className="btn btn--ghost btn--sm" onClick={onClearAll}>
            Сбросить
          </button>
        )}

        <div className="filterbar__spacer" />

        <div className="filterbar__meta">
          Показано <b>{totalShown}</b> из {total}
        </div>

        <div className="filterbar__rightActions">
          <button
            className="btn btn--primary btn--sm"
            onClick={onCreate}
            disabled={!canCreate}
            title={canCreate ? undefined : 'Нет права на создание (students:write)'}
          >
            <Icon name="plus" size={13} />
            <span>Добавить ученика</span>
          </button>
        </div>
      </div>
    </div>
  );
}
